
import Vue from "vue";
import { getCurrentUser } from "../auth";
import LoggedHeader from "./LoggedHeader.vue";
import NonLoggedHeader from "./NonLoggedHeader.vue";
export default Vue.extend({
  name: "Header",
  data: () => ({}),
  components: {
    NonLoggedHeader,
    LoggedHeader,
  },
  computed: {
    isAuthenticated() {
      void this.$route;
      return getCurrentUser();
    },
  },
  methods: {
    handleMobileMenuToggle(isOpen: boolean) {
      this.$root.$emit('mobile-menu-toggle', isOpen);
    },
  },
});
